import {
  CHAT_SORT_VALUES,
  CHAT_TYPES,
} from "@circle-react/components/SettingsApp/CommunityInbox/Sidebar/constants";
import type {
  ChatSortType,
  ChatType,
} from "@circle-react/types/CommunityBot/ChatSort";
import { z } from "zod";

const chatTypeValues = Object.values(CHAT_TYPES) as [ChatType, ...ChatType[]];
const chatSortValues = Object.values(CHAT_SORT_VALUES) as [
  ChatSortType,
  ...ChatSortType[],
];

// `chat_type` intentionally has no `.catch(default)` — it must stay
// `undefined` when absent from the URL so `useAiInboxBootstrap` can tell "no
// filter chosen yet" (eligible for the AI-paused auto-jump) apart from
// "explicitly set to `all`" (must survive reload as-is).
export const aiInboxSearchSchema = z.object({
  chat_type: z.enum(chatTypeValues).optional().catch(undefined),
  sort: z.enum(chatSortValues).catch(CHAT_SORT_VALUES.LATEST),
  agent_id: z.coerce.number().int().optional().catch(undefined),
  q: z.string().optional().catch(undefined),
});

export type AiInboxSearch = z.infer<typeof aiInboxSearchSchema>;
